import React from "react";
import { useAppSelector } from "@/store/store";
import { useIntl } from "react-intl";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import { hasEntries } from "../../functions/array";
import { fullAddress } from "../../functions/users";
import Logo from "../HomeContainer/Logo";

// HELPER FUNCTIONS //
const getCustomTextFromArray = (estateArray) => {
  const freetextArray = estateArray.filter(([field, val]) =>
    field.includes("freetext"),
  );
  return freetextArray;
};

const filterFreetext = ([field, freetext]) => freetext;

const NoPropertyAvailable = () => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        {formatMessage({ id: "property_management.no_property_available" })}
      </Typography>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
  },
  freetext: {
    marginBottom: theme.spacing(),
  },
}));

const PropertyManagementProfile = ({ estate }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const currentEstate = useAppSelector((state) => state.estates.currentEstate);

  // Conditional rendering for when estate is null
  if (!estate) {
    return <NoPropertyAvailable />;
  }

  const { address, logo } = estate;
  const freeTextArray = getCustomTextFromArray(
    Object.entries(estate || Object.create(null)),
  );

  const renderFreetexts = ([field, freetext], index) => {
    return (
      <div
        key={`${field}-${index}`}
        className={classes.freetext}
        dangerouslySetInnerHTML={{ __html: freetext }}
      />
    );
  };

  return (
    <div className={classes.root}>
      {logo && <Logo logo={logo} />}

      {estate && <Typography variant="h5">{estate.name}</Typography>}
      {estate && <Typography variant="h6">{estate.infoText}</Typography>}

      {address && (
        <Typography variant="subtitle1" style={{ marginBottom: "20px" }}>
          {fullAddress(address)}
        </Typography>
      )}

      {address && estate && (
        <Typography variant="h6"> {estate.emailAddress}</Typography>
      )}

      <Typography variant="h6" gutterBottom>
        {formatMessage({ id: "profile.property_management.headline" })}
      </Typography>

      {hasEntries(freeTextArray) &&
        freeTextArray.filter(filterFreetext).map(renderFreetexts)}

      <Typography variant="h6" gutterBottom>
        {formatMessage({
          id: "profile.property_management.info_your_estate",
        })}
      </Typography>

      {currentEstate && currentEstate.infoText && (
        <Typography variant="subtitle1">{currentEstate.infoText}</Typography>
      )}
    </div>
  );
};

export default PropertyManagementProfile;
